import assetsMutations from "./mutations.js";
import assetsActions from "./actions.js";
import assetsGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      treeSelectedItem: {},
      activeAssetDetailsPlyr:{},
    };
  },
  mutations: assetsMutations,
  actions: assetsActions,
  getters: assetsGetters,
};
